import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

import React from 'react';

import PropertiesListPage from '../propertiesList.page';

/**
 * Modal component for selecting a Google Analytics property.
 * It reuses the PropertiesListPage component.
 * @param {Object} props - Component props.
 * @param {boolean} props.open - Controls the open/close state of the modal.
 * @param {function} props.onClose - Callback function to close the modal.
 * @param {function} props.onPropertySelect - Callback function when a property is selected,
 * receives the selected property object.
 */
function PropertySelectModal({ open, onClose, onPropertySelect }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md' // Adjust max width as needed
      fullWidth
      scroll='paper' // Make content scrollable if it overflows
      aria-labelledby='property-select-dialog-title'
    >
      <DialogTitle id='property-select-dialog-title'>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography variant='h6' component='span'>
            Select a Google Analytics Property
          </Typography>
          <IconButton aria-label='close' onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {' '}
        {/* Add dividers for visual separation */}
        {/* Render PropertiesListPage inside the modal */}
        <PropertiesListPage
          onPropertySelect={onPropertySelect} // Pass the selection handler
          isModal={true} // Indicate that it's being used inside a modal
        />
      </DialogContent>
    </Dialog>
  );
}

export default PropertySelectModal;
